


import { createSlice } from "@reduxjs/toolkit";

const currentPaymentJourneySlice = createSlice({
    name: 'currentPaymentJourneySlice',
    initialState: {},
    reducers: {
        setCurrentPaymentJourney: (state, action): any => {
            return action.payload
        },
        updateCurrentPaymentJourney: (state, action): any => {
            return {
                ...state,
                ...action.payload
            }
        },
        resetPaymentForRetry: (state): any => {
            const newState: any = {...state}
            delete newState.paymentProcessCompleted
            return {
                ...newState
            }
        },
    },
});
export const { setCurrentPaymentJourney, updateCurrentPaymentJourney, resetPaymentForRetry } = currentPaymentJourneySlice.actions;
export default currentPaymentJourneySlice.reducer;